class PreviewCropsSection extends React.Component {

    //The props is passed from the view(cshtml)
    constructor(props) {
        super(props);
        this.state = PreviewCropsSection.modelToState(props);
        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    //set the react state to the the same values as the model
    static modelToState(props) {
        return {
            CropsViewModel: props.model.CropsViewModel,
            MediaViewModel: props.model.MediaViewModel,
            PriceViewModel: props.model.PriceViewModel,
            ContactViewModel: props.model.ContactViewModel,
            CurrentSite: props.model.CurrentSite,
            QueryString: props.model.QueryString,
            Translations: props.model.Translations,
            formattedPrice: props.model.PriceViewModel.FormattedPrice,
            formattedLeasePrice: props.model.PriceViewModel.FormattedLeasePrice,
            formattedFractionalPrice: props.model.PriceViewModel.FormattedFractionalPrice,
            HighlightErrors: {},
            FormErrors: [],
            InputErrors: {},
            IsInTranslationEditorMode: props.model.IsInTranslationEditorMode
        };
    }

    componentWillReceiveProps(Props) {
        this.setState({
            CropsViewModel: Props.model.CropsViewModel,
            ContactViewModel: Props.model.ContactViewModel
        });
    }

    //executes a command when you click on a button
    handleButtonClick(button) {
        var state = this.state;

        switch (button) {
            case "save":
                if (this.props.model.IsRegisteredUser || this.state.ContactViewModel.EmailVerified) {
                    SaveAndExitModal();
                }
                else {
                    //close all other sections, go directly to contact section to ask them to create an account to save
                    if ($("#saveExitMessage").text() == this.getTranslation("saveExitMessageCreateAccount")) {
                        this.props.model.SaveExitMethod("exitNewUser");
                    }
                    else {
                        if (this.state.ContactViewModel.EmailIsRegistered) {
                            $("#saveExitMessage").text(this.getTranslation("saveExitMessageVerify"));
                            $("#VerifyPasswordSection").hide();
                            $("#VerifyPasswordSaveAndExit").fadeIn();
                        }
                        else {
                            $("#saveExitMessage").text(this.getTranslation("saveExitMessageCreateAccount"));
                        }

                        $("#saveExitMessage").fadeIn();
                        $("#SavedFor30Days").fadeIn();
                        OpenSpecificHeaderAccordion(ContactSectionID);
                        $('input[id="Email"]').focus();
                        $("#SubmitBtn").hide();
                        $("#submit-section").fadeIn();
                    }
                }

                window.scrollTo({ top: 0, behavior: 'smooth' });
                break;
            case "help":
                $("#saveExitMessage").fadeOut();
                $("#SavedFor30Days").fadeOut();
                break;
        }

    }

    getTranslation(key) {
        return this.state.IsInTranslationEditorMode ?
            <span dangerouslySetInnerHTML={{ __html: this.state.Translations[key] }}></span> :
            this.state.Translations[key];
    }

    //the html and react components to render
    render() {
        var showContact = true;
        var showDescription = true;

        if (this.state.CurrentSite == "Aircraft") {
            showContact = false;
            showDescription = false;
        }

        // Header Text 
        var baleText = "";
        if (this.state.CropsViewModel.BaleTypeCatID != 0 && this.state.CropsViewModel.BaleTypeCatID != "0") {
            var baleCatID = this.state.CropsViewModel.BaleTypeCatID;
            baleCatID = baleCatID.toString();

            var result = this.state.CropsViewModel.BaleList.filter(function (baleType) {
                return baleType.Value == baleCatID;
            });
            if (result != null)
                baleText = result[0].Text;
        }

        var headerText = baleText;

        var title = [];
        if (headerText == "") {
            title.push(
                <h2 key={1} className="preview-title" style={{ color: '#747575' }}>
                    Crop Type
                </h2>
            );  //Make this translation
        }
        else {
            title.push(
                <h2 key={1} className="preview-title" style={{ color: 'black' }}>
                    {headerText}
                </h2>
            );
        }

        var price = [];
        if (this.state.PriceViewModel.Price == "0" || this.state.PriceViewModel.Price == "") {
            price.push(
                <div key={1} className="preview-price" style={{ color: '#747575', paddingBottom: '20px' }}>
                    {this.getTranslation("Price")}: {this.getTranslation("Call")}
                </div>
            );
        }
        else {
            price.push(
                <div key={1} className="preview-price" style={{ color: 'black', paddingBottom: '20px' }}>
                    {this.state.formattedPrice != "" ? this.state.PriceViewModel.CurrencyCodeSelected : ""} {this.state.formattedPrice}
                </div>
            );
        }

        var description = [];
        if (showDescription) {
            if (this.state.CropsViewModel.Description == "") {
                description.push(
                    <div key={1} className="preview-description" style={{ color: '#747575', paddingBottom: '20px' }}>
                        {this.getTranslation("DescriptionPlaceholder")}
                    </div>
                );
            }
            else {
                description.push(
                    <div key={1} className="preview-description" style={{ maxHeight: '15vh', overflowY: 'hidden', overflowX: 'hidden', color: 'black', paddingBottom: '20px' }}>
                        {this.state.CropsViewModel.Description + " "}
                    </div>
                );
            }
        }

        var contact = [];
        if (showContact) {
            if (this.state.ContactViewModel.FirstName == "" && this.state.ContactViewModel.LastName == "") {
                contact.push(
                    <div key={1} className="preview-contact" style={{ color: '#747575' }}>
                        {this.getTranslation("NamePlaceholder")}
                    </div>
                );
            }
            else {
                contact.push(
                    <div key={1} className="preview-contact" style={{ color: 'black' }}>
                        {this.state.ContactViewModel.FirstName + " " + this.state.ContactViewModel.LastName}
                    </div>
                );
            }
        }

        var cityState = [];
        if (showContact) {
            var locVM = this.state.ContactViewModel.LocationViewModel;
            var city = locVM.City || '';
            var st = locVM.State || '';
            var country = locVM.Country || '';
            var cityStateText = city ? (st ? city + ', ' + st : city) : st;
            if (!cityStateText && country) cityStateText = country;

            if (cityStateText == "") {
                cityState.push(
                    <div key={1} className="preview-cityState" style={{ color: '#747575' }}>
                        {this.getTranslation("LocationPlaceholder")}
                    </div>
                );
            }
            else {
                cityState.push(
                    <div key={1} className="preview-cityState" style={{ color: 'black' }}>
                        {cityStateText}
                    </div>
                );
            }
        }

        //Render each of the sections here
        return (
            <div className="side-container" id="box">
                {this.getTranslation("QuickPreview")}
                <div className="preview-box">
                    {title}

                    <div className="preview-selected-image" onClick={(e) => { OpenMediaFullSize(e) }}>
                        {/*Preview Image handled in JQUERY with media tool*/}
                    </div>
                    <div className="thumbnails" style={{ paddingBottom: '20px' }}>
                        {/*Thumbnails handled in JQUERY with media tool*/}
                    </div>

                    {price}
                    {description}
                    {contact}
                    {cityState}
                </div>
                <button role="link" className="side-btn save-exit-btn" onClick={(e) => { this.handleButtonClick("save"); }}>{this.getTranslation("SaveAndExit")}</button>
                <div className="help-side PrimaryBGC">
                    <h2>{this.getTranslation("NeedHelp")}</h2>
                    <div className="help-buttons">
                        <a className="help-text" href={"tel:1-" + this.props.model.HelpPhoneNumber}>
                            <i className="fa fa-phone" aria-hidden="true"></i> &nbsp; {this.props.model.HelpPhoneNumber}
                        </a>
                        <a className="help-email" href={this.props.model.FeedBackEmailLink} title={this.getTranslation("OpensInANewTab")} target="_blank">
                            <i className="fa fa-envelope" aria-hidden="true"></i> &nbsp; {this.getTranslation("Contact")}
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

export default PreviewCropsSection;
global.PreviewCropsSection = PreviewCropsSection;